import { httpGet } from './apiService';
import { PagedResult } from '@models/pagination';
import { PressRelease } from '@models/pressRelease';
import { TaggedSlugEntityPreview } from '@models/tag';
import { TaggedSlugEntityPublicApiService } from './taggedSlugEntityPublicApiService';

export class PressReleasePublicService extends TaggedSlugEntityPublicApiService<PressRelease> {
    constructor() {
        super('/api/press-release');
    }

    public async getPagedPressReleaseList(
        pageNumber: number,
        rowsPerPage: number,
        languageId: number
    ): Promise<PagedResult<TaggedSlugEntityPreview>> {
        const url = `${this.baseUrl}/paged/${pageNumber}/${rowsPerPage}/${languageId}`;

        const result = await httpGet(url);

        return result.json();
    }
}
